import "./MyAccount.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Account from "./sections/Account";
export default function MyAccountPage() {
  return <div>
      <Header />

      <main>
        <Account />
      </main>

      <Footer />
    </div>;
}